<template>
  <v-main>
    <!-- / Mini Variant Sidebar -->
    <v-container fluid>
      <div class="dj-page-head">
        <div class="dj-page-head__text dj-page-head__row">
          <backbutton></backbutton>
          <h1 class="dj-page-title">Suppliers</h1>
        </div>
        <div class="dj-page-actions">
          <v-btn fab small depressed color="primary" :to="`/suppliers/create`">
            <v-icon dark> mdi-plus </v-icon>
          </v-btn>
        </div>
      </div>
      <!-- <v-row>
        <v-col sm="4">
          <v-autocomplete
            ref="project"
            v-model="form.project_id"
            :items="projectItems"
            label="Select Project"
            prepend-inner-icon="mdi-ferry"
            @change="getData()"
            outlined
          ></v-autocomplete>
        </v-col>
        <v-col sm="4">
          <v-autocomplete
            ref="category"
            v-model="form.category_id"
            :items="categoryItems"
            @change="getSubCategory(), getData()"
            label="Select Category"
            prepend-inner-icon="mdi-ferry"
            outlined
          ></v-autocomplete>
        </v-col>
        <v-col sm="4" v-if="sub_categoryItems.length > 1">
          <v-autocomplete
            ref="sub_category"
            v-model="form.sub_category_id"
            :items="sub_categoryItems"
            @change="getData()"
            label="Select Sub Category"
            prepend-inner-icon="mdi-ferry"
            outlined
          ></v-autocomplete>
        </v-col>
      </v-row> -->
      <v-progress-linear
        v-if="isLoading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <v-row v-else>
        <v-col md="12">
          <v-card elevation="6">
            <v-simple-table fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Sr No</th>
                    <th class="text-left">Name</th>
                    <th class="text-left">Email</th>
                    <th class="text-left">Phone</th>
                    <th class="text-left">Currency</th>
                    <th class="text-right">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(supplier, i) in suppliers" :key="supplier.id">
                    <td>{{ i + 1 }}</td>
                    <td>{{ supplier.name }}</td>
                    <td>{{ supplier.email }}</td>
                    <td>{{ supplier.phone_no }}</td>
                    <td>{{ supplier.currency?.description }}</td>
                    <!-- <td>{{ supplier.sub_category.details }}</td> -->
                    <td class="text-right">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="mx-2"
                            icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            color="primary"
                            :to="`/suppliers/${supplier.id}`"
                          >
                            <v-icon dark> mdi-pencil </v-icon>
                          </v-btn>
                        </template>
                        <span>Edit Supplier</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import backbutton from "@/components/backbutton.vue";
export default {
  components: { backbutton },
  name: "SuppliersPage",
  data() {
    return {
      search_keyword: "",
      suppliers: [],
      currencyItems: [{ id: 0, text: "Select Currency", value: "0" }],
      isLoading: false,
    };
  },
  mounted() {
    this.getMasters();
    this.getData();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get(`suppliers/masters`);
      masters = masters.data;
      masters.currencies.forEach((currency) => {
        this.currencyItems.push({
          id: currency.id,
          text: currency.description,
          value: currency.id,
        });
      });
    },
    async getData() {
      this.isLoading = true;
      this.search_keyword = this.search_keyword ? this.search_keyword : "";
      let suppliers = [];
      let query = "search_keyword=" + this.search_keyword;
      suppliers = await axios.get(`suppliers?${query}`);
      this.suppliers = suppliers.data.data;
      this.isLoading = false;
    },
  },
};
</script>
